import { api } from '../context/AuthContext';

export async function searchFoods(query) {
  const res = await api.get('/api/foods/search', { params: { q: query } });
  return res.data;
}

export async function getFoodDetails(fdcId) {
  const res = await api.get(`/api/foods/${fdcId}`);
  return res.data;
}

export async function addFoodLog(data) {
  const res = await api.post('/api/logs', data);
  return res.data;
}

export async function getRecentFoods() {
  const res = await api.get('/api/logs/recent');
  return res.data;
}

export async function getFrequentFoods() {
  const res = await api.get('/api/logs/frequent');
  return res.data;
}

export async function copyDay(sourceDate, targetDate, mealTypes) {
  const res = await api.post('/api/logs/copy-day', { sourceDate, targetDate, mealTypes });
  return res.data;
}

export async function copyMeal(logIds, targetDate, targetMealType) {
  const res = await api.post('/api/logs/copy-meal', { logIds, targetDate, targetMealType });
  return res.data;
}

export async function getCustomFoods() {
  const res = await api.get('/api/custom-foods');
  return res.data;
}

export async function createCustomFood(data) {
  const res = await api.post('/api/custom-foods', data);
  return res.data;
}

export async function updateCustomFood(id, data) {
  const res = await api.put(`/api/custom-foods/${id}`, data);
  return res.data;
}

export async function deleteCustomFood(id) {
  const res = await api.delete(`/api/custom-foods/${id}`);
  return res.data;
}

export async function getWater(date) {
  const res = await api.get('/api/water', { params: { date } });
  return res.data;
}

export async function addWater(amount_ml, date) {
  const res = await api.post('/api/water', { amount_ml, date });
  return res.data;
}

export async function deleteWater(id) {
  const res = await api.delete(`/api/water/${id}`);
  return res.data;
}

export async function getWaterSummary(startDate, endDate) {
  const res = await api.get(`/api/water/summary?startDate=${startDate}&endDate=${endDate}`);
  return res.data;
}

export async function getRestaurants() {
  const res = await api.get('/api/restaurants');
  return res.data;
}

export async function getRestaurantMenu(name) {
  const res = await api.get(`/api/restaurants/${encodeURIComponent(name)}/menu`);
  return res.data;
}

export async function lookupBarcode(barcode) {
  const res = await api.get(`/api/foods/barcode/${encodeURIComponent(barcode)}`);
  return res.data;
}
